<template>
  <div class="loadingBox">
    <div class="loading">
      <CarLottie />
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import CarLottie from '@core/components/CarLottie.vue'

export default defineComponent({
  components: { CarLottie }
})
</script>

<style scoped lang="less">
.loadingBox {
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(220, 216, 216, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9;
}
</style>
